import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FONT_FAMILY } from "../common/sharedFunctions";
import PageSEO from '../components/SEO/PageSEO';

export default function TermCondition() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const navigate = useNavigate();

  const sections = [
    { heading: t('term_condition_heading1'), content: t('term_condition_para2') },
    { heading: t('term_condition_heading2'), content: t('term_condition_para3') },
    { heading: t('term_condition_heading3'), content: t('term_condition_para4') },
    { heading: t('term_condition_heading4'), content: t('term_condition_para5') },
    { heading: t('term_condition_heading5'), content: t('term_condition_para6') },
    { heading: t('term_condition_heading6'), content: t('term_condition_para7') },
    { heading: t('term_condition_heading7'), content: t('term_condition_para8') },
    { heading: t('term_condition_heading8'), content: t('term_condition_para9') },
    { heading: t('term_condition_heading9'), content: t('term_condition_para10') },
    { heading: t('term_condition_heading10'), content: t('term_condition_para11') },
    { heading: t('term_condition_heading11'), content: t('term_condition_para12') },
    { heading: t('term_condition_heading12'), content: t('term_condition_para13') },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#009689]/5 via-white to-[#319F44]/5" style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
      <PageSEO
        title="Terms & Conditions"
        description="Gruwcer Delivery Terms and Conditions - Read our terms of service for using our delivery platform."
        keywords="terms and conditions, terms of service, Gruwcer Delivery terms, delivery terms, user agreement"
        path="/term-condition"
      />
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
              <ArrowLeft className="w-5 h-5 text-gray-600" />
            </button>
            <img src="/gruwcer-logo.png" alt="Gruwcer Delivery" onClick={() => navigate('/')} className="h-8 w-auto object-contain cursor-pointer hover:opacity-80 transition-opacity" />
          </div>
        </div>
      </header>

      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-900 mb-4 text-center"
            style={{ fontFamily: FONT_FAMILY }}
          >
            {t('term_condition')}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-gray-600 text-center mb-12"
            style={{ fontFamily: FONT_FAMILY }}
          >
            {t('term_condition_para1')}
          </motion.p>

          <div className="space-y-4">
            {sections.map((section, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 + i * 0.03 }}
                className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
              >
                <h3 className="text-base font-semibold text-gray-900 mb-2" style={{ fontFamily: FONT_FAMILY }}>
                  {i + 1}. {section.heading}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: FONT_FAMILY }}>
                  {section.content}
                </p>
              </motion.div>
            ))}

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center"
            >
              <p className="text-sm text-gray-600 mb-2" style={{ fontFamily: FONT_FAMILY }}>
                {t('term_condition_para14')}
              </p>
              {settings?.contact_email && (
                <a href={`mailto:${settings.contact_email}`} className="text-[#009689] font-medium hover:underline text-sm" style={{ fontFamily: FONT_FAMILY }}>
                  {settings.contact_email}
                </a>
              )}
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
